/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentVersion {
    getFixupPrototypeFunction() { return AwsSsmListDocumentVersion.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentVersion>): AwsSsmListDocumentVersion {
        let obj = Object.assign(new AwsSsmListDocumentVersion(), model);
        AwsSsmListDocumentVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentVersion>): AwsSsmListDocumentVersion {
        if (!model) return null;
        return AwsSsmListDocumentVersion.newInstance(<AwsSsmListDocumentVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentVersion) {
        if (!obj) return;

        models.AwsSsmListDocumentVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentVersion): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.document_creation_time === "string") {
            this.document_creation_time = new Date(<string><any>this.document_creation_time);
        }
    }

    sysId: string;

    /**
     * Version of the Systems Manager Document
     */
    document_version: string;

    document_creation_time: Date;

}
